import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=2f213528&scoped=true"
import script from "./ToolBar.vue?vue&type=script&lang=js"
export * from "./ToolBar.vue?vue&type=script&lang=js"
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=2f213528&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f213528",
  null
  
)

export default component.exports